import { defineComponent, ref, reactive, computed, provide, watch, nextTick, toRef, unref, onMounted, PropType, toRefs } from 'vue';
import { FilterModel } from '@Apps/Search/Src/Models/FilterModel';
import { getLocationSelectionDisplay, getGuestsSelectionDisplay, getDatesSelectionDisplay, getActiveFilterCount } from '@Composables/FilterDisplayComposables';

export default defineComponent({

    components: {},

    props: {

        filter: {
            type: Object as PropType<FilterModel>,
            required: true
        },

        isFilterVisible: Boolean

    },

    emits: ["onClick"],


    setup(props, context) {


        const filter = toRef(props, 'filter');


        const onToggleFilter = () => {

            context.emit("onClick")
        };
        const onLocationClicked = () => {

            context.emit("onClick", "location")
        };


        const onDatesClicked = () => {

            context.emit("onClick", "dates")
        };

        const onGuestsClicked = () => {

            context.emit("onClick", "guests")
        };

        const datesSelectionDisplay = computed(() => {

            return getDatesSelectionDisplay(filter.value);
        });

        const locationSelectionDisplay = computed(() => {

            return getLocationSelectionDisplay(filter.value);
        });

        const guestsSelectionDisplay = computed(() => {

             // for now we always show the number of guests with the "true" for has been active.
             // in the existing searchbar we had a property that was monitored if 'enabled',
             // so that on the homepage version we could show 'met wie' on first load, and only
             // change to guest counts once the 'popup' was opened for the first time.
             // in the current version we do not have a homepage equivalent, so for now
             // we will always show 2 persons by default, or the actual selection. 
            return getGuestsSelectionDisplay(filter.value, true ); 
        })

        const totalCriteriaCount = computed(() => {


            return getActiveFilterCount(filter.value);        });


        return {

            filter,
            onToggleFilter,
            onLocationClicked,
            onDatesClicked,
            onGuestsClicked,

          
            datesSelectionDisplay,
            locationSelectionDisplay,
            guestsSelectionDisplay,

            totalCriteriaCount,

        };




    }

});

